export default __webpack_public_path__ + "static/media/author.2563a6fd.jpg";